const appName = 'com.plecto.app.plecto';
export default function setupScreenSaverDismiss() {
	try {
		if (typeof WebOSServiceBridge !== 'undefined') {
			log('Setting up screen saver fix');
			// eslint-disable-next-line no-undef
			const bridge = new WebOSServiceBridge();
		
			bridge.onservicecallback = onServiceCallback(bridge);
		
			const callResponse = bridge.call('luna://com.webos.service.tvpower/power/registerScreenSaverRequest', JSON.stringify({
				subscribe: true,
				clientName: appName
			}));

			log('Screen saver service register response', callResponse);
		}
	}
	catch (ex) {
		log('Error setting up screen saver fix', ex);
		Screen.logErrorToSentry(ex);
	}
}

function onServiceCallback(bridge) {
	return (messageJson) => {
		try {
			const message = JSON.parse(messageJson);
			if (message.returnValue) {
				if (message.state === 'Active') {
					log('Screen saver request received, sending prevent message');
					const callResponse = bridge.call('luna://com.webos.service.tvpower/power/responseScreenSaverRequest', JSON.stringify({
						clientName: appName,
						ack: false,
						timestamp: message.timestamp
					}));
					log('Screen saver service prevent response', callResponse);
				} else if (message.subscribed) {
					log('Subscribed to screen saver service');
				} else {
					log('Unrecognized message from screen saver service', message);
				}
			} else {
				log('Incorrect message from com.webos.service.tvpower', message);
			}
		}
		catch (ex) {
			log('Error parsing com.webos.service.tvpower message', ex);
			Screen.logErrorToSentry(ex);
		}
	};
}
